import request from '@/utils/request'

// 采购报表
export function fetchList(params) {
    return request({
        url: '/report/purchase',
        method: 'get',
        params: params
    })
}


// WEBPACK FOOTER //
// ./src/api/scm/purchasing.js